export default __webpack_public_path__ + "static/media/slide2.30ec3051.svg";